import React, { useState, useEffect } from "react";
import location_icon from "../../ulits/images/location_icon.svg";
import dateicon from "../../ulits/images/date-icon.svg";
import CustomLoader from "../../components/CustomeLoader";
import { useDispatch, useSelector } from "react-redux";
import { blogAction } from "../../_actions/blogDetail.action";
import { status } from "../../_constants/commonLhd";
import { Link, useNavigate } from "react-router";
import { configs } from "../../config";
import parse from "html-react-parser";
import Accordion from "react-bootstrap/Accordion";

function BlogListing() {
  const [loader, setLoading] = useState(true);
  const [blog, setBlogs] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const blogData = useSelector((state) => state.blog);
  const [visibleCount, setVisibleCount] = useState(6);
  console.log("24 blogs", blogData);
  console.log("blogs", blog);

  // console.log("24 blogs", blogData.blogDetail_data);
  // useEffect(() => {
  //   if (blogData?.blog_status === status.SUCCESS) {
  //     setBlogs(blogData.blog_data);
  //   }
  // }, [blogData?.blog_data]);

  useEffect(() => {
    if (blogData && blogData.blog_status === status.SUCCESS) {

      const activeBlogs = blogData.blog_data.filter(
        blog => blog.status === true
      );
      setBlogs(activeBlogs);
    }

  }, [blogData]);

  useEffect(() => {
    dispatch(blogAction.getBlogDetail());
  }, []);
  const faqData = useSelector((state) => state.faq);
  const faqList =
    faqData?.faq_data?.filter((item) => item.status === true) || [];
  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      setLoading(false);
    }, 600);
  }, []);

  const getUniqueSlug = (slug) => {
    let count = 0;
    blog.forEach((blogs) => {
      if (blogs.slug === slug) {
        count++;
      }
    });

    if (count > 1) {
      let newSlug = `${slug}-${count - 1}`;
      return newSlug;
    }
    return slug;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";

    const [datePart] = dateString.split(",");
    const [day, month, year] = datePart.split("/");

    const date = new Date(`${year}-${month}-${day}`);
    const dayNum = date.getDate();
    const monthName = date
      .toLocaleString("en-GB", { month: "long" })
      .toUpperCase();
    const yearNum = date.getFullYear();

    const suffix = (d) => {
      if (d > 3 && d < 21) return "th";
      switch (d % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    return `${dayNum}${suffix(dayNum)} ${monthName} ${yearNum}`;
  };

  return (
    <>
      {loader ? (
        <CustomLoader />
      ) : (
        <div className="main-wrapper">
          <div className="blog-listing-section">
            <div className="container">
              <div className="blog-listing-title text-center">
                <h1>ALL ABOUT LHD BLOG</h1>
              </div>
              <div className="row">
                {blog &&
                  blog.length > 0 &&
                  blog.slice(0, visibleCount).map((blog, index) => {
                    const uniqueSlug = getUniqueSlug(blog.slug, blog);
                    return (
                      <div
                        className="col-lg-4 col-md-6 col-sm-6 col-xs-6 col-12"
                        key={index}
                      >
                        <div className="blog-listing-box">
                          <div className="blog-listing-img">
                            <img
                              src={`${configs.localApiUrl}${blog?.image}`}
                              alt="blog"
                              onClick={() =>
                                navigate(`/blog-details/${uniqueSlug}`, {
                                  state: blog,
                                })
                              }
                              style={{ cursor: "pointer" }}
                            />
                          </div>

                          <div className="blog-listing-text">
                            <h1>{blog.title}</h1>
                            <p>{blog && blog.description
                              ? parse(blog.description)
                              : null}</p>
                            {/* <p>{parse(blog.description)}</p> */}
                            <div className="meta-middle-unit">
                              <div className="blog-listing-date">
                                <img src={dateicon} alt="date" />
                                <span>
                                  {blog?.createdAt &&
                                    formatDate(blog.createdAt)}
                                </span>
                              </div>
                              <div className="blog-listing-date">
                                <img src={location_icon} alt="location" />
                                <span>{blog.location}</span>
                              </div>
                            </div>
                            <button
                              className="btn primary-btn"

                              onClick={() =>
                                navigate(`/blog-details/${uniqueSlug}`, {
                                  state: blog,
                                })
                              }
                            >
                              READ MORE
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
              {visibleCount < blog.length && (
                <button
                  className="primary-btn-list"
                  title="LOAD MORE"
                  onClick={() => setVisibleCount((prev) => prev + 3)}
                >
                  LOAD MORE
                </button>
              )}
            </div>
          </div>
          <div className="stm-accordion-single-unit">
            <div className="container">
              <div className="stm-accordion-title">
                <h3>FREQUENTLY ASKED QUESTIONS</h3>
              </div>
              {faqList.length > 0 &&
                faqList.map((item, index) => (
                  <Accordion key={index}>
                    <Accordion.Item eventKey={index.toString()}>
                      <Accordion.Header>{item.que}</Accordion.Header>
                      <Accordion.Body>{item.ans}</Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default BlogListing;
